<template>
  <div class="primarycolor categoryselect 444">
  <Select
    :value="selectedOption"
    value-key="id"
    @change="updateOption"
    placeholder="Select"
    :popper-class="darkTheme">
      <Option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item">
      </Option>
  </Select>
</div>
</template>
<script>
export default {
  data() {
    return {
      selectedOption: {
        name: null,
      },
      showMenu: false,
      placeholderText: 'Please select an item',
    };
  },
  props: {
    options: {
      type: [Array, Object],
    },
    selected: {},
    noUpperCase: Boolean,
    isDarkTheme: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.selectedOption = this.selected;
  },
  computed: {
    popperClass() {
      const commonClass = 'categoryoption';
      return (this.noUpperCase) ? commonClass.concat(' lowerCase') : commonClass;
    },
    darkTheme() {
      return this.isDarkTheme ? 'dropdown-dark' : '';
    },
  },
  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.$emit('updateOption', this.selectedOption);
    },
  },
};
</script>
<style lang="scss">
.categoryoption{
  &.lowerCase{
    .el-select-dropdown__item{
    text-transform: inherit !important;
  }
  }
}
</style>
